import React, { Fragment, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-monokai';
import AceEditor from 'react-ace';

export default (props) => {
  const { doUpdateItem, item } = props;
  const [buttonIcon, setButtonIcon] = useState('icon_script');
  const [scriptCode, setScriptCode] = useState(item.scriptCode);

  const { i18n } = useTranslation();

  useEffect(() => {
    setScriptCode(item.scriptCode || '');
  }, [item]);

  const onInputChanged = (value, state, name) => {
    state(value);
    const payload = {};
    payload[name] = value;
    doUpdateItem(payload);
  };

  return (
    <Fragment>
      <div className="form-group">
        <button
          className="settings-conditional-button-create-condition"
          onClick={() => {}}
          onMouseEnter={() => {
            setButtonIcon('icon_script_hover');
          }}
          onMouseLeave={() => {
            setButtonIcon('icon_script');
          }}
          data-toggle="modal"
          data-target="#modal-code-editor"
        >
          <img
            alt=""
            src={require(`../../../assets/images/${buttonIcon}.svg`)}
          />
          &nbsp;&nbsp;{i18n.t('Abrir editor de código')}
        </button>
      </div>

      {/* CODE EDITOR */}
      <div
        className="modal fade"
        id="modal-code-editor"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered ajust-centered-mod" role="document">
          <div className="modal-content ajust-modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{i18n.t('Script')}</h5>
              <br />
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="code-editor-script mt-2">
                <div className="code-editor-script-default">
                  {`function (event , done) {`}
                </div>
                <AceEditor
                  placeholder=""
                  mode="javascript"
                  theme="monokai"
                  name="code-editor"
                  className="response-editor-ace code-editor mt-2"
                  id="scriptCode"
                  onChange={(value) =>
                    onInputChanged(value, setScriptCode, 'scriptCode')
                  }
                  fontSize={12}
                  showPrintMargin
                  showGutter
                  highlightActiveLine={false}
                  value={scriptCode}
                  setOptions={{
                    enableBasicAutocompletion: false,
                    enableLiveAutocompletion: false,
                    enableSnippets: false,
                    showLineNumbers: true,
                    tabSize: 2,
                  }}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
              >
                {i18n.t('fechar')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
